export default __webpack_public_path__ + "static/media/sed.9dba6fe4.svg";